import { HTTP, authHeader } from './http-service';

class BusinessRegistrationPeriodService {
  getBusinessRegistrationPeriodList(payload) {
    return HTTP.get(`/BusinessRegistrationPeriod/${payload.businessRegistrationNumber}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getBusinessRegistrationSuspensionList(payload) {
    return HTTP.get(
      `/BusinessRegistrationPeriod/${payload.businessRegistrationNumber}/suspensions`,
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  createPeriod(payload) {
    return HTTP.post(
      `/BusinessRegistrationPeriod/${payload.businessRegistrationNumber}`,
      {},
      { headers: authHeader() },
    ).then((response) => {
      return response.data;
    });
  }

  addBusinessRegistrationSuspension(payload) {
    return HTTP.post(
      `/BusinessRegistrationPeriod/${payload.businessRegistrationNumber}/suspension`,
      { reason: payload.reason, startDate: payload.startDate, endDate: payload.endDate },
      { headers: authHeader() },
    ).then((response) => {
      return response.data;
    });
  }

  liftBusinessRegistrationSuspension(payload) {
    return HTTP.put(
      `/BusinessRegistrationPeriod/${payload.businessRegistrationNumber}/lift-suspension`,
      {
        liftReason: payload.liftReason,
        businessRegistrationSuspensionId: payload.businessRegistrationSuspensionId,
        liftedDate: payload.liftedDate,
      },
      { headers: authHeader() },
    ).then((response) => {
      return response.data;
    });
  }
}

export default new BusinessRegistrationPeriodService();
